<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="headingOndernemingen">
            <button aria-controls="collapseOndernemingen" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseOndernemingen" data-bs-toggle="collapse" type="button">
                Ondernemingen
            </button>
        </h2>
        <div aria-labelledby="headingOndernemingen" class="accordion-collapse collapse"
             data-bs-parent="#accordionExample"
             id="collapseOndernemingen">
            <div class="accordion-body">
                Bij overdracht van ondernemingsvermogen door schenking geldt onder voorwaarden een vrijstelling op grond
                van de bedrijfsopvolgingsregeling (BOR). Deze regeling voorziet in een (gedeeltelijke) vrijstelling van
                schenkbelasting bij voortzetting van de onderneming door de ontvanger.
                <div class="space20"></div>
                Voorwaarde is onder andere dat het
                ondernemingsvermogen minimaal vijf jaar in bezit is geweest van de schenker en dat de ontvanger het
                bedrijf
                ten minste vijf jaar voortzet. Beleggingsvermogen en overtollige liquide middelen zijn uitgesloten. Bij
                overdracht van aandelen moet worden vastgesteld of sprake is van een ‘materiële onderneming’. Complexe
                waarderingsvraagstukken (goodwill, stille reserves) spelen hier vaak een rol.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingOndernemingen1">
            <button aria-controls="collapseOndernemingen1" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseOndernemingen1" data-bs-toggle="collapse"
                    type="button">
                BSN/RSIN onderneming
            </button>
        </h2>
        <div aria-labelledby="headingOndernemingen1" class="accordion-collapse collapse"
             data-bs-parent="#accordionExample"
             id="collapseOndernemingen1">
            <div class="accordion-body">
                Het 'BSN/RSIN onderneming' is het BSN van de natuurlijke persoon die de onderneming drijft of het RSIN
                van de rechtspersoon of samenwerkingsverband.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingGoingConcern">
            <button aria-controls="collapseGoingConcern" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseGoingConcern" data-bs-toggle="collapse"
                    type="button">
                Goingconcernwaarde onderneming en schenkbelasting
            </button>
        </h2>
        <div aria-labelledby="headingGoingConcern" class="accordion-collapse collapse"
             id="collapseGoingConcern">
            <div class="accordion-body">
                De <strong>goingconcernwaarde</strong> van een onderneming is de waarde die wordt toegekend aan een
                bedrijf als geheel, in het geval dat het wordt voortgezet.
                Hierbij wordt rekening gehouden met toekomstige winstverwachtingen, lopende contracten, klantenbestand,
                personeel en overige bedrijfsmiddelen.
                <div class="space20"></div>
                Bij een schenking van een onderneming is deze waarde van belang voor de heffing van <strong>schenkbelasting</strong>.
                De Belastingdienst baseert zich op de waarde in het economische verkeer,
                en dat is doorgaans de goingconcernwaarde.
                <div class="space20"></div>
                Een lagere waarde, zoals de liquidatiewaarde, is alleen toepasbaar als aannemelijk is dat het bedrijf
                niet wordt voortgezet. Voor de juiste fiscale afhandeling is het raadzaam
                om een onafhankelijke waardering op te laten stellen.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingLiquidatiewaarde">
            <button aria-controls="collapseLiquidatiewaarde" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseLiquidatiewaarde" data-bs-toggle="collapse"
                    type="button">
                Liquidatiewaarde van de onderneming
            </button>
        </h2>
        <div aria-labelledby="headingLiquidatiewaarde" class="accordion-collapse collapse"
             id="collapseLiquidatiewaarde">
            <div class="accordion-body">
                De <strong>liquidatiewaarde</strong> is de waarde van een onderneming of vermogensbestanddeel in het
                geval dat het wordt beëindigd en alle activa afzonderlijk worden verkocht,
                zonder dat er sprake is van voortzetting van de bedrijfsactiviteiten.
                <div class="space20"></div>
                Deze waarde ligt meestal lager dan de <em>goingconcernwaarde</em>, omdat er bij gedwongen verkoop vaak
                minder wordt opgebracht en goodwill of toekomstige winstverwachtingen geen rol spelen.
                <div class="space20"></div>
                De liquidatiewaarde kan van belang zijn bij het bepalen van de schenkbelasting als aannemelijk is dat de
                onderneming na de schenking niet wordt voortgezet.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingKoopsom">
            <button aria-controls="collapseKoopsom" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseKoopsom" data-bs-toggle="collapse"
                    type="button">
                Koopsom voor de onderneming
            </button>
        </h2>
        <div aria-labelledby="headingKoopsom" class="accordion-collapse collapse"
             id="collapseKoopsom">
            <div class="accordion-body">
                De ‘koopsom overgedragen aandeel onderneming’ is de koopsom die de begiftigde heeft betaald aan de
                schenker voor het overgedragen aandeel onderneming.
                <div class="space20"></div>
                Indien een onderneming wordt verkocht voor een bedrag lager dan de werkelijke waarde dan is het verschil
                tussen de waarde van het overgedragen aandeel in de onderneming en de koopsom voor het overgedragen
                aandeel in de onderneming een schenking.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingBOR">
            <button aria-controls="collapseBOR" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseBOR" data-bs-toggle="collapse"
                    type="button">
                Toepassen Bedrijfsopvolgingsregeling (BOR) bij schenking onderneming
            </button>
        </h2>
        <div aria-labelledby="headingBOR" class="accordion-collapse collapse"
             id="collapseBOR">
            <div class="accordion-body">
                Begiftigde die (een deel van) de onderneming van schenker voortzet, kan
                gebruik maken van de bedrijfsopvolgingsregeling. Begiftigde kan een
                vrijstelling aanvragen voor de schenkbelasting. Er moet wel worden
                voldaan aan de voorwaarden voor de bedrijfsopvolgingsregeling.
                <div class="space20"></div>
                De vrijstelling houdt in dat je (gedeeltelijke) vrijstelling kunt aanvragen voor de schenkbelasting. Je
                betaalt dan minder
                of geen schenkbelasting. Er gelden wel bepaalde voorwaarden, zoals:<br/>
                - Het bedrijf moet een actieve, lopende onderneming zijn. Als het alleen gaat om beleggingen valt dat
                niet
                onder deze regeling.<br/>
                - De schenker was ten minste 5 jaar eigenaar van de onderneming.<br/>
                - De onderneming moet ten minste 3 jaar worden voortgezet door dezelfde persoon.<br/>
                <br/>

                Lees meer over de voorwaarden en mogelijkheden van de bedrijfsopvolgingsregeling op de <a
                    href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/themaoverstijgend/brochures_en_publicaties/erf-en-schenkbelasting-en-de-bedrijfsopvolgingsregeling"
                    target="_blank">website van de Belastingdienst</a>.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingAcuut">
            <button aria-controls="collapseAcuut" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseAcuut" data-bs-toggle="collapse"
                    type="button">
                Acute belastingclaim over ondernemingsvermogen
            </button>
        </h2>
        <div aria-labelledby="headingAcuut" class="accordion-collapse collapse"
             id="collapseAcuut">
            <div class="accordion-body">
                Met “acute belastingclaim over ondernemingsvermogen” bedoelt de Belastingdienst de belasting die direct
                verschuldigd zou zijn als op het moment van de schenking met de onderneming zou worden afgerekend. Denk
                aan inkomstenbelasting over stille reserves en goodwill of een aanmerkelijkbelangheffing bij aandelen in
                een BV. Deze claim kan de waarde van het ondernemingsvermogen verlagen voor de berekening van de
                schenkbelasting.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingStil">
            <button aria-controls="collapseStil" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseStil" data-bs-toggle="collapse"
                    type="button">
                Waarde stille reserves in overgedragen ondernemingsvermogen
            </button>
        </h2>
        <div aria-labelledby="headingStil" class="accordion-collapse collapse"
             id="collapseStil">
            <div class="accordion-body">
                De 'waarde stille reserves in overgedragen ondernemingsvermogen' is het
                verschil tussen de waarde in het economisch verkeer en de boekwaarde
                van een vermogensbestanddeel in het overgedragen deel van de
                onderneming.
            </div>
        </div>
    </div>


</div>

